<template>
  <div class="pager">
    <ul class="pages">
      <li v-for="(item, index) in pages" :key="index" :class="item.className"><a @click="changePage(item.page)" v-html="item.label"></a></li>
    </ul>
  </div>
</template>

<script>

function buildPager(pager){

  let pages = [];
  let items = 4;
  let center = Math.floor(items/2);
  let len = Math.min(pager.total_pages, items);
  let start = pager.current_page - center;
  let disabled = false;

  if(pager.total_items == 0){
    this.pages = [];
    return;
  }

  if(pager.current_page+center >= pager.total_pages){
    start = Math.max(pager.total_pages - items, 0);
  } else if(pager.current_page - center < 0){
    start = 0;
  }

  disabled = pager.current_page == 0;

  pages.push({
    label: '<i class="las la-angle-double-left"></i>',
    page: disabled ? -1 : 0,
    className: disabled ? 'disabled' : '',
  });

  pages.push({
    label: '<i class="las la-angle-left"></i>',
    page: disabled ? -1 : pager.current_page-1,
    className: disabled ? 'disabled' : '',
  });

  for(let i = 0; i < len; i++)
  {
    let page = i+start;
    let active = page == pager.current_page;
    pages.push({
      label: page+1,
      page: active ? -1 : page,
      className: active ? 'active' : ''
    });
  }

  if(pages[2].page > 0) {
    pages[2] = {
      label: '...',
      page: -1,
      className: 'elipse'
    }
  }

  if(pages[pages.length-1].label < pager.total_pages) {
    pages[pages.length-1] = {
      label: '...',
      page: -1,
      className: 'elipse'
    }
  }

  disabled = pager.total_pages - 1 == pager.current_page;

  pages.push({
    label: '<i class="las la-angle-right"></i>',
    // page: pager.current_page >= pager.total_pages - 1 ? -1 : pager.current_page+1,
    page: disabled ? -1 : pager.current_page+1,
    className: disabled ? 'disabled' : '',
  });

  pages.push({
    label: '<i class="las la-angle-double-right"></i>',
    page: disabled ? -1 : pager.total_pages - 1,
    className: disabled ? 'disabled' : '',
  });

  return pages;
}

export default {
  name: 'Pager',

  props: {
    options: {
      default: () => {}
    }
  },

  computed: {
    pages(){
      if(this.options.total_pages){
        return buildPager(this.options);
      } else {
        return [];
      }
    }
  },

  methods: {
    changePage(item){
      this.$emit('changePage', item);
    }
  }

}
</script>

<style scoped lang="scss">
  .pager
  {
    margin-top: 20px;
    margin-bottom: 20px;

    .pages
    {
      margin: 0;
      padding: 0;
      text-align: center;
    }

    LI
    {
      display: inline-block;
      text-align: center;
      // color: $brown-1;

      A
      {
        color: inherit;
      }

      &.active
      {
        A
        {
          // background: $brown-1;
          // color: white;
          font-weight: bold;
          cursor: default;
        }
      }

      &.elipse
      {
        A
        {
          cursor: default;
        }
      }

      &.disabled
      {
        A
        {
          cursor: not-allowed;
          opacity: .6;
        }
      }

    }

    A
    {
      display: block;
      min-width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 6px;
      cursor: pointer;
    }
  }
</style>